import { render, staticRenderFns } from "./BannerPhotoComponent.vue?vue&type=template&id=7e57edaf&scoped=true"
import script from "./BannerPhotoComponent.vue?vue&type=script&lang=js"
export * from "./BannerPhotoComponent.vue?vue&type=script&lang=js"
import style0 from "./BannerPhotoComponent.vue?vue&type=style&index=0&id=7e57edaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e57edaf",
  null
  
)

export default component.exports